import React, { useEffect, useState } from "react";
import { Box, Button, Stack } from "@origin-digital/ods-core";
import { OE_234_MBOX } from "../../../mbox";

export const DEFAULT_CONTENT = {
  primaryLink: "/moving/",
  primaryLabel: "Move house",
  secondaryLink: "/electricity-gas/plans.html",
  secondaryLabel: "Compare plans",
};
interface PersonalisedContentProps {
  menuVisible: boolean;
}

interface Offer {
  content: OfferContent[];
}

interface OfferContent {
  primaryLink?: string;
  primaryLabel?: string;
  secondaryLink?: string;
  secondaryLabel?: string;
}

interface PersonalisedContentProps {
  menuVisible: boolean;
}

export const PersonalisedContent = ({
  menuVisible,
}: PersonalisedContentProps) => {
  const [content, setContent] = useState<OfferContent>({ ...DEFAULT_CONTENT });

  useEffect(() => {
    if (menuVisible && window?.adobe?.target?.getOffer) {
      //@ts-ignore
      window.adobe.target.getOffer({
        mbox: OE_234_MBOX,
        success: (offer: Offer[]) => {
          const mboxContent =
            (offer && offer[0]?.content[0]) ?? DEFAULT_CONTENT;
          setContent(mboxContent);
        },
        error: () => {},
      });
    }
  }, [menuVisible]);

  if (!menuVisible) {
    return null;
  }

  return (
    <Box paddingX="small" paddingY="large">
      <Stack alignX="left" space="small">
        {content.primaryLink && content.primaryLabel && (
          <Button fullWidth={true} href={content.primaryLink}>
            {content.primaryLabel}
          </Button>
        )}

        {content.secondaryLink && content.secondaryLabel && (
          <Button
            fullWidth={true}
            variant="outlined"
            href={content.secondaryLink}
          >
            {content.secondaryLabel}
          </Button>
        )}
      </Stack>
    </Box>
  );
};
